import { render, staticRenderFns } from "./riskDeviceDetail.vue?vue&type=template&id=3b89b15a&scoped=true"
import script from "./riskDeviceDetail.vue?vue&type=script&lang=js"
export * from "./riskDeviceDetail.vue?vue&type=script&lang=js"
import style0 from "./riskDeviceDetail.vue?vue&type=style&index=0&id=3b89b15a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b89b15a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b89b15a')) {
      api.createRecord('3b89b15a', component.options)
    } else {
      api.reload('3b89b15a', component.options)
    }
    module.hot.accept("./riskDeviceDetail.vue?vue&type=template&id=3b89b15a&scoped=true", function () {
      api.rerender('3b89b15a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/security/components/riskDeviceDetail.vue"
export default component.exports